import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id,
    expireDate,
    password,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.das.project.share, {
        id,
        expireDate,
        password,
    }, options);
    if (error) return { error, status };
    return content || {};
};
